/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import '../../../App.css'

interface props {
    content: string
    redirectFun?: (path: string) => void
}

const Loader: React.FC<props> = ({ content, redirectFun }) => {

    useEffect(() => {
        if (content && content.includes('invalid')) {

            setTimeout(() => {
                if (redirectFun)
                    redirectFun('/viewer/')
            }, 5000);
        }
    }, [content])

    return (
        <div className='invalid'>
            <div className='invalidbox'>
                <div className='invalidtext'>
                    <div className="lds-ring"><div></div><div></div><div></div><div></div></div>{content}
                </div>
            </div>
        </div>
    )
}

export default Loader